import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Syslog, SummarySysLog } from '../../../models/admModel/system.model';
import * as config from '../backend.config';
import { Page } from '../../../models/admModel/page'; //'src/app/components/adm/log/page';

// ----------------------------------------------
// Service for Administrator
// Component: logComponent
// ----------------------------------------------

const ADDRS_API = config.API + '/systemlog/events';
const ADDRS_APIDNS = config.API + '/settings/dns';

// API description for all commnication with BACK-END for systemlog events management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------
//  Method    URLS                  Actions                   View
//  POST      api/events            create events             może każda rola
//  GET       api/events            get all events            może tylko rola ADMIN
//  GET       api/events?sum        get summary for events    może tylko rola ADMIN
//  DELETE    api/events/{id}       remove event by :id       może tylko rola ADMIN
//  DELETE    api/events            remove all events         może tylko rola ADMIN

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })

  export class SystemService {
    constructor(private http: HttpClient) { }
    // *********************************************************
    // używane w widoku dla administratora: Admin-System Log

    // pobranie podsumowania eventów dla widgetów
    // może też być : `${ADDRS_API}`+
    getEventsSummary():Observable<any> {
      return this.http.get(ADDRS_API + `/summary`);
    }

    // pobranie logu eventów paging po stronie servera
    getEvents(page: Page): Observable<any> {
        return this.http.get(ADDRS_API + `?pageSize=${page.size}&pageNumber=${page.pageNumber}`);
      }

    deleteEvent(id: any): Observable<any> {
        return this.http.delete(ADDRS_API + `/${id}`);
      }

    deleteEvents(): Observable<any> {
        return this.http.delete(ADDRS_API);
      }

    // *********************************************************
    // używane w widoku dla administratora: Admin-System Settings
    // zarządzanie wpisami DNS

    // pobranie listy dns paging po stronie servera
    // zwraca strukturę w modelu SettingsDns + obsługa page
    getDns(page: Page): Observable<any> {
      return this.http.get(ADDRS_APIDNS + `?pageSize=${page.size}&pageNumber=${page.pageNumber}`);
    }

    // rejestracja pojedynczego wpisu DNS
    // domyślnie parametr dnsstatus po stronie BE ustawić na 'off'
    // parametr data w modelu SettingsDnsSingle
    registerDns(data: any): Observable<any> {
      return this.http.post(ADDRS_APIDNS, data);
    }

    // update informacji o rekordzie DNS
    updateDns(data: any): Observable<any> {
      return this.http.put(ADDRS_APIDNS, data);
    }

    // usunięcie rekordu DNS
    deleteDns(id: any): Observable<any> {
      return this.http.delete(ADDRS_APIDNS  + `/${id}`);
    }

}


